import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.5",
  "description": "Turborepo 1.5 brings the Monorepo Handbook, drops the 'run' command, improves pruning, and much more!",
  "date": "2022/09/19",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.5 is a huge leap forward for our documentation and DX, as well as bringing big improvements to turbo prune:"
  }, {
    "heading": "",
    "content": "The Monorepo Handbook: We've built the missing manual for your monorepo - a guide on workspaces, code sharing, integrating common tools and much more."
  }, {
    "heading": "",
    "content": "Drop the run: turbo run <task> can now be shortened to turbo <task>"
  }, {
    "heading": "",
    "content": "turbo prune now supports pnpm and yarn 2+: Pruning your monorepo is now supported in pnpm and yarn@berry."
  }, {
    "heading": "",
    "content": "Improved environment variables in turbo.json: Environment variables are now first-class citizens in your Turborepo pipeline configuration."
  }, {
    "heading": "",
    "content": "Changes to package.json hashing: We've improved how we hash package.json when running tasks."
  }, {
    "heading": "",
    "content": "Update today by running npm install turbo@latest."
  }, {
    "heading": "the-monorepo-handbook",
    "content": "Setting up a monorepo for the first time often means navigating a lot of new concepts. You'll need to understand workspaces, package installation, sharing code and dependency management - and a lot more."
  }, {
    "heading": "the-monorepo-handbook",
    "content": "This often meant that folks who wanted to set up a monorepo from scratch had to piece information together from different documentation sites. First pnpm, then tsup, then back to changesets, then back to Turborepo for dessert."
  }, {
    "heading": "the-monorepo-handbook",
    "content": "We want to fill this gap with the Monorepo Handbook. We've built guides on how to integrate all the tools you'll need to make ship happen with your monorepo, including guides on:"
  }, {
    "heading": "the-monorepo-handbook",
    "content": "Installing Packages"
  }, {
    "heading": "the-monorepo-handbook",
    "content": "Linting"
  }, {
    "heading": "the-monorepo-handbook",
    "content": "Development Tasks"
  }, {
    "heading": "the-monorepo-handbook",
    "content": "Building Apps"
  }, {
    "heading": "the-monorepo-handbook",
    "content": "Publishing Packages"
  }, {
    "heading": "drop-the-run",
    "content": "You can now run tasks with the Turborepo CLI using turbo <task>."
  }, {
    "heading": "drop-the-run",
    "content": "If your task name conflicts with a built-in turbo subcommand, we'll run our subcommand instead. That means you shouldn't name your tasks things like prune, run, or login - since those are built-in subcommands."
  }, {
    "heading": "drop-the-run",
    "content": "turbo run <task> will continue to work, and there are no plans to deprecate it."
  }, {
    "heading": "prune-now-supported-on-pnpm-and-yarn-2",
    "content": "We're delighted to announce that turbo prune now supports in pnpm, yarn, and yarn 2+."
  }, {
    "heading": "prune-now-supported-on-pnpm-and-yarn-2",
    "content": "You can use turbo prune to create a pruned subset of your monorepo with a dedicated lockfile--with the correct dependencies needed for a given target application and its dependencies. This is especially useful for using efficiently Turborepo within a Docker image."
  }, {
    "heading": "prune-now-supported-on-pnpm-and-yarn-2",
    "content": "As part of the new handbook, we've also added a section on using turbo prune to build docker images."
  }, {
    "heading": "prune-now-supported-on-pnpm-and-yarn-2",
    "content": "Check out our previous blog on prune to learn more."
  }, {
    "heading": "environment-variables-in-turbojson",
    "content": "We've introduced two new keys to turbo.json - env and globalEnv. These allow environment variables to be configured separately from tasks:"
  }, {
    "heading": "environment-variables-in-turbojson",
    "content": "globalEnv and env allow you to specify a list of environment variables without $ prefixes. This makes the configuration file significantly easier to read. Read more in our updated docs."
  }, {
    "heading": "environment-variables-in-turbojson",
    "content": "To help migrate from the previous syntax, we've prepared a codemod. You can run npx @turbo/codemod migrate-env-var-dependencies."
  }, {
    "heading": "environment-variables-in-turbojson",
    "content": "This work builds on the automatic env variable detection we added in 1.4.0."
  }, {
    "heading": "changes-to-packagejson-hashing",
    "content": "The package.json file in each workspace is now always considered an input for tasks in that workspace. This means that if you change the definition for a task in package.json, we want to invalidate any caches from the previous definition."
  }, {
    "heading": "changes-to-packagejson-hashing",
    "content": "This also counts for the package.json in the root. Changes to the root package.json will invalidate tasks in the root workspace."
  }, {
    "heading": "changes-to-packagejson-hashing",
    "content": "This helps make Turborepo's cache a bit smarter, and less likely to trip up when task definitions change."
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo v1.4 in August, we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "9.5k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "440k weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "15 years of compute time saved through Remote Caching on Vercel, saving over a 1 year per week, up 2x since July"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of our contributors including our core team."
  }, {
    "heading": "community",
    "content": "This release was brought to you by the contributions of: @7flash, @afady, @alexander-young, @atilafassina, @bguedes-moz, @bobaaaaa, @brunojppb, @chris-olszewski, @DoctorJohn, @erj826, @futantan, @gsoltis, @HosseinAgha, @ivov, @jaredpalmer, @joelhooks, @knownasnaffy, @laurentlucian, @leerob, @MarceloAlves, @mattpocock, @mauricekleine, @mehulkar, @Misikir, @nareshbhatia, @nathanhammond, @pakaponk, @PhentomPT, @renovate, @ruisaraiva19, @samuelhorn, @shemayas, @shuding, @t-i-0414, @theurgi, @tknickman, @yanmao-cc, and more!"
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "the-monorepo-handbook",
    "content": "The Monorepo Handbook"
  }, {
    "id": "drop-the-run",
    "content": "Drop the run"
  }, {
    "id": "prune-now-supported-on-pnpm-and-yarn-2",
    "content": "Prune now supported on pnpm and yarn 2+"
  }, {
    "id": "environment-variables-in-turbojson",
    "content": "Environment variables in turbo.json"
  }, {
    "id": "changes-to-packagejson-hashing",
    "content": "Changes to package.json hashing"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Callout} from '#components/callout';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#the-monorepo-handbook",
  title: _jsx(_Fragment, {
    children: "The Monorepo Handbook"
  })
}, {
  depth: 2,
  url: "#drop-the-run",
  title: _jsxs(_Fragment, {
    children: ["Drop the ", _jsx("code", {
      children: "run"
    })]
  })
}, {
  depth: 2,
  url: "#prune-now-supported-on-pnpm-and-yarn-2",
  title: _jsx(_Fragment, {
    children: "Prune now supported on pnpm and yarn 2+"
  })
}, {
  depth: 2,
  url: "#environment-variables-in-turbojson",
  title: _jsxs(_Fragment, {
    children: ["Environment variables in ", _jsx("code", {
      children: "turbo.json"
    })]
  })
}, {
  depth: 2,
  url: "#changes-to-packagejson-hashing",
  title: _jsxs(_Fragment, {
    children: ["Changes to ", _jsx("code", {
      children: "package.json"
    }), " hashing"]
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.5"
    }), "\n", "\n", _jsx(Date, {
      children: "Monday, September 19th, 2022"
    }), "\n", _jsx(Authors, {
      authors: ['mattpocock', 'gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar', 'chrisolszewski']
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 1.5 is a ", _jsx(_components.strong, {
        children: "huge leap forward for our documentation and DX"
      }), ", as well as bringing big improvements to ", _jsx(_components.code, {
        children: "turbo prune"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/guides",
          children: _jsx(_components.strong, {
            children: "The Monorepo Handbook"
          })
        }), ": We've built the missing manual for your monorepo - a guide on workspaces, code sharing, integrating common tools and much more."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#drop-the-run",
          children: _jsxs(_components.strong, {
            children: ["Drop the ", _jsx(_components.code, {
              children: "run"
            })]
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo run <task>"
        }), " can now be shortened to ", _jsx(_components.code, {
          children: "turbo <task>"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#prune-now-supported-on-pnpm-and-yarn-2",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "turbo prune"
            }), " now supports pnpm and yarn 2+"]
          })
        }), ": Pruning your monorepo is now supported in ", _jsx(_components.code, {
          children: "pnpm"
        }), " and ", _jsx(_components.code, {
          children: "yarn@berry"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#environment-variables-in-turbojson",
          children: _jsxs(_components.strong, {
            children: ["Improved environment variables in ", _jsx(_components.code, {
              children: "turbo.json"
            })]
          })
        }), ": Environment variables are now first-class citizens in your Turborepo pipeline configuration."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#changes-to-packagejson-hashing",
          children: _jsxs(_components.strong, {
            children: ["Changes to ", _jsx(_components.code, {
              children: "package.json"
            }), " hashing"]
          })
        }), ": We've improved how we hash ", _jsx(_components.code, {
          children: "package.json"
        }), " when running tasks."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "the-monorepo-handbook",
      children: "The Monorepo Handbook"
    }), "\n", _jsx(_components.p, {
      children: "Setting up a monorepo for the first time often means navigating a lot of new concepts. You'll need to understand workspaces, package installation, sharing code and dependency management - and a lot more."
    }), "\n", _jsxs(_components.p, {
      children: ["This often meant that folks who wanted to set up a monorepo from scratch had to piece information together from different documentation sites. First ", _jsx(_components.code, {
        children: "pnpm"
      }), ", then ", _jsx(_components.code, {
        children: "tsup"
      }), ", then back to ", _jsx(_components.code, {
        children: "changesets"
      }), ", then back to Turborepo for dessert."]
    }), "\n", _jsxs(_components.p, {
      children: ["We want to fill this gap with ", _jsx(_components.a, {
        href: "/docs/guides",
        children: "the Monorepo Handbook"
      }), ". We've built guides on how to integrate all the tools you'll need to make ship happen with your monorepo, including guides on:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/managing-dependencies",
          children: "Installing Packages"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/tools/eslint",
          children: "Linting"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/developing-applications",
          children: "Development Tasks"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/constructing-ci",
          children: "Building Apps"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/publishing-libraries",
          children: "Publishing Packages"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.h2, {
      id: "drop-the-run",
      children: ["Drop the ", _jsx(_components.code, {
        children: "run"
      })]
    }), "\n", _jsx("iframe", {
      className: "mt-6 h-72 w-full max-w-xl sm:h-96",
      src: "https://www.youtube.com/embed/PEgk2v6KntY",
      title: "YouTube video player",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    }), "\n", _jsxs(_components.p, {
      children: ["You can now run tasks with the Turborepo CLI using ", _jsx(_components.code, {
        children: "turbo <task>"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "- turbo run build"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ turbo build"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "- turbo run lint build test"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ turbo lint build test"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If your task name conflicts with a built-in ", _jsx(_components.code, {
        children: "turbo"
      }), " subcommand, we'll run our subcommand instead. That means you shouldn't name your tasks things like ", _jsx(_components.code, {
        children: "prune"
      }), ", ", _jsx(_components.code, {
        children: "run"
      }), ", or ", _jsx(_components.code, {
        children: "login"
      }), " - since those are built-in subcommands."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run <task>"
      }), " will continue to work, and there are no plans to deprecate it."]
    }), "\n", _jsx(_components.h2, {
      id: "prune-now-supported-on-pnpm-and-yarn-2",
      children: "Prune now supported on pnpm and yarn 2+"
    }), "\n", _jsxs(_components.p, {
      children: ["We're delighted to announce that ", _jsx(_components.a, {
        href: "/docs/reference/prune",
        children: _jsx(_components.code, {
          children: "turbo prune"
        })
      }), " now supports in pnpm, yarn, and yarn 2+."]
    }), "\n", _jsxs(_components.p, {
      children: ["You can use ", _jsx(_components.code, {
        children: "turbo prune"
      }), " to create a pruned subset of your monorepo with a dedicated lockfile--with the correct dependencies needed for a given target application and its dependencies. This is especially useful for using efficiently Turborepo within a Docker image."]
    }), "\n", _jsxs(_components.p, {
      children: ["As part of the new handbook, we've also added a section on using ", _jsx(_components.code, {
        children: "turbo prune"
      }), " to ", _jsx(_components.a, {
        href: "/docs/guides/tools/docker",
        children: "build docker images"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Check out our previous ", _jsx(_components.a, {
        href: "/blog/turbo-0-4-0#experimental-pruned-workspaces",
        children: "blog on prune"
      }), " to learn more."]
    }), "\n", _jsxs(_components.h2, {
      id: "environment-variables-in-turbojson",
      children: ["Environment variables in ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["We've introduced two new keys to ", _jsx(_components.code, {
        children: "turbo.json"
      }), " - ", _jsx(_components.code, {
        children: "env"
      }), " and ", _jsx(_components.code, {
        children: "globalEnv"
      }), ". These allow environment variables to be configured ", _jsx(_components.em, {
        children: "separately"
      }), " from tasks:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"globalDependencies\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-   \"$DATABASE_URL\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ \"globalEnv\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+   \"DATABASE_URL\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ ],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      \"dependsOn\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       \"$BUILD_ENV\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+     \"env\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+       \"BUILD_ENV\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+     ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "globalEnv"
      }), " and ", _jsx(_components.code, {
        children: "env"
      }), " allow you to specify a list of environment variables ", _jsx(_components.em, {
        children: "without"
      }), " ", _jsx(_components.code, {
        children: "$"
      }), " prefixes. This makes the configuration file significantly easier to read. Read more ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#adding-environment-variables-to-task-hashes",
        children: "in our updated docs"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["To help migrate from the previous syntax, we've prepared a codemod. You can run ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate-env-var-dependencies"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["This work builds on the ", _jsx(_components.a, {
        href: "/blog/turbo-1-4-0",
        children: "automatic env variable detection"
      }), " we added in 1.4.0."]
    }), "\n", _jsxs(_components.h2, {
      id: "changes-to-packagejson-hashing",
      children: ["Changes to ", _jsx(_components.code, {
        children: "package.json"
      }), " hashing"]
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "package.json"
      }), " file in each workspace is now ", _jsx(_components.em, {
        children: "always"
      }), " considered an input for tasks in that workspace. This means that if you change the ", _jsx(_components.em, {
        children: "definition"
      }), " for a task in ", _jsx(_components.code, {
        children: "package.json"
      }), ", we want to invalidate any caches from the previous definition."]
    }), "\n", _jsxs(_components.p, {
      children: ["This also counts for the ", _jsx(_components.code, {
        children: "package.json"
      }), " in the root. Changes to the root ", _jsx(_components.code, {
        children: "package.json"
      }), " will invalidate tasks in the root workspace."]
    }), "\n", _jsx(_components.p, {
      children: "This helps make Turborepo's cache a bit smarter, and less likely to trip up when task definitions change."
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-1-4-0",
        children: "Turborepo v1.4 in August"
      }), ", we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "9.5k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "440k weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["15 years of compute time saved through ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Remote Caching on Vercel"
        }), ", saving over a 1 year per week, up 2x since July"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of our contributors including our core team."
    }), "\n", _jsx(_components.p, {
      children: "This release was brought to you by the contributions of: @7flash, @afady, @alexander-young, @atilafassina, @bguedes-moz, @bobaaaaa, @brunojppb, @chris-olszewski, @DoctorJohn, @erj826, @futantan, @gsoltis, @HosseinAgha, @ivov, @jaredpalmer, @joelhooks, @knownasnaffy, @laurentlucian, @leerob, @MarceloAlves, @mattpocock, @mauricekleine, @mehulkar, @Misikir, @nareshbhatia, @nathanhammond, @pakaponk, @PhentomPT, @renovate, @ruisaraiva19, @samuelhorn, @shemayas, @shuding, @t-i-0414, @theurgi, @tknickman, @yanmao-cc, and more!"
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
